import { useCallback, useMemo, useState } from "react";

import apiConfig, { SupApiEnv } from "@/../config/api";
import useApiEnvState from "@/hooks/api-env/useApiEnvState";

interface EnvSwitchReturn {
  apiEnv: SupApiEnv;
  displayApiEnv: boolean;
  setApiEnv: (apiEnv: SupApiEnv) => void;
  isLoading: boolean;
  switchAllowed: boolean;
  options: { label: string; value: SupApiEnv }[];
}

export default function useApiEnvSwitch(): EnvSwitchReturn {
  const [isUiLoading, setUiLoading] = useState<boolean>(false);

  const [apiEnv, setApiEnvValue] = useApiEnvState();

  const isLoading = useMemo(() => isUiLoading, [isUiLoading]);

  const switchAllowed = useMemo(() => !isLoading && apiConfig.switchAllowed, [isLoading]);

  const setApiEnv = useCallback(
    (apiEnv: SupApiEnv) => {
      if (switchAllowed) {
        setApiEnvValue(apiEnv);

        // Reloading current page with the new environment
        setUiLoading(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    [switchAllowed, setApiEnvValue]
  );

  return {
    apiEnv,
    displayApiEnv: apiConfig.displayOrigin,
    isLoading,
    options: Object.entries(apiConfig.origins)
      .map(([key, value]) => ({ label: value.label, value: key as SupApiEnv }))
      .filter(option => apiConfig.allowedOrigins.includes(option.value)),
    switchAllowed,
    setApiEnv,
  };
}
